import React from "react"

export const AktuelleFormularsaetze = ({ size = 1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={66 * size}
      height={82 * size}
      viewBox="0 0 66 82"
      overflow="visible"
    >
      <style>
        {
          ".prefix__st4{stroke-linecap:square}.prefix__st4,.prefix__st5{fill:none;stroke:#034055;stroke-width:3}"
        }
      </style>
      <path fill="#e5edf0" d="M17 0h49v67H17z" />
      <defs>
        <filter
          id="prefix__Adobe_OpacityMaskFilter"
          filterUnits="userSpaceOnUse"
          x={1}
          y={6}
          width={55}
          height={73}
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={1}
        y={6}
        width={55}
        height={73}
        id="prefix__path-2-inside-1_1_"
      >
        <path
          d="M5 9h47c.6 0 1 .4 1 1v65c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V10c0-.6.4-1 1-1z"
          fill="#fff"
          filter="url(#prefix__Adobe_OpacityMaskFilter)"
        />
      </mask>
      <path
        d="M5 9h47c.6 0 1 .4 1 1v65c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V10c0-.6.4-1 1-1z"
        mask="url(#prefix__path-2-inside-1_1_)"
        fill="none"
        stroke="#034055"
        strokeWidth={6}
      />
      <path fill="#ffd62e" d="M0 18h43.9v64H0z" />
      <path
        className="prefix__st4"
        d="M8.1 32.2l2.7 2.2 7.7-6.7M8.1 44.8l2.7 2.2 7.7-6.7"
      />
      <path
        className="prefix__st5"
        d="M7.6 57.1h29.5M7.6 64.1h29.5M7.6 71.1h29.5"
      />
    </svg>
  )
}
